import Control from "../../Control";
import TextField from "./TextField";
import FileUpload from "../FileUpload/FileUpload";
import {ServerAPI} from "../../ServerAPI";
import post = ServerAPI.post;
import Delegate from "../../Delegate";


export default class ImageTextField extends Control {
	private _TextFieldSettings: object;
	private _textField: TextField;
	private _uploadButton: FileUpload;
	private EvChanged: Delegate;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvChanged = new Delegate()
		this._TextFieldSettings = {};
		super._initFields(settings);
	}

	_render()
	{
		this._initComponent('<div class="image-text-field"></div>');

		this._textField = new TextField({
			...this._TextFieldSettings,
			ParentNode: this._root,
			EvChanged: () => this.EvChanged.fire(this)
		})

		this._uploadButton = new FileUpload({
			ParentNode: this._root,
			RK: 'SelectFile',
			EvFileChanged: () => this.fileSelected()
		})

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	async fileSelected()
	{
		let file = this._uploadButton.getFile();
		if (!file)
			return;
		let data = await post(`/athlete/creates3Link`, {
			id: 0,
			name: file.name
		}) as {
			uploadUrl: string,
			getUrl: string
		}

		const response = await fetch(data.uploadUrl, {
			method: 'PUT',
			body: file
		});

		await response.text();

		this._textField.setValue(data.getUrl)

		this.EvChanged.fire(this)
	}

	setValue(value: string)
	{
		this._textField.setValue(value)
	}

	getValue()
	{
		return this._textField.getValue();
	}
}